<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="发放完成"
    :visible.sync="dialogFormVisible"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <el-form-item label="付款账户" prop="paymentAccount">
        <el-input v-model="formData.paymentAccount" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="付款银行" prop="paymentBank">
        <el-input v-model="formData.paymentBank" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="付款流水号" prop="paymentSerialNo">
        <el-input
          v-model="formData.paymentSerialNo"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { accountReg, bankReg, serialNumberReg } from "@/hooks/regex";

export default {
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      formData: {
        subsidyNo: "",
        // 1-发放，2-发放成功，3-发放失败
        operateType: 2,
        paymentAccount: "",
        paymentBank: "",
        paymentSerialNo: ""
      },
      rules: {
        paymentAccount: [
          { required: true, message: "请输入付款账户", trigger: "blur" },
          {
            pattern: accountReg,
            trigger: "blur",
            message: "请输入正确的付款账户"
          }
        ],
        paymentBank: [
          { required: true, message: "请输入付款银行", trigger: "blur" },
          { pattern: bankReg, trigger: "blur", message: "请输入正确的付款银行" }
        ],
        paymentSerialNo: [
          { required: true, message: "请输入付款流水号", trigger: "blur" },
          {
            pattern: serialNumberReg,
            trigger: "blur",
            message: "请输入正确的付款流水号"
          }
        ]
      },
      btnLoading: false
    };
  },
  watch: {
    dialogFormVisible: function(val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    }
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    openDialog(orderNo) {
      this.formData.subsidyNo = orderNo;
      this.dialogFormVisible = true;
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 确认发放完成
    async save() {
      let params = this.formData;
      this.HttpService.post(
        "/autoapp-default-server-recovery/api/oldMachineSubsidy/subsidyIssued",
        params
      ).then(res => {
        if (res.statusCode === 200) {
          this.$message.success("操作成功");
          this.dialogFormVisible = false;
          this.$emit('distributionFinishedSuccess')
        }
      });
    },
    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldMachineSubsidy/components/DistributionSuccessDialog.vue